import { RequestBuilder } from '../request_builder'

export class OwnerRequestBuilder extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'balances/by_asset'
  }

  getByAsset (data) {
    this.filters.push(data.asset)
    this.filters.push(data.accountId)
    return this
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/owner_request_builder.js